import { Box, Grid, Modal } from '@mui/material';
import _ from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Utility from '../../../../app/utility';
import { SupportSheetStatus } from '../../../SupportSheet/models/SupportSheetModel';
import FixtureModel from '../../models/FixtureModel';
import { FixtureQuickSummarySelector, setShowQuickSummaryModal } from './reducers/FixtureQuickSummaryReducer';

const FixtureQuickSummary: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(FixtureQuickSummarySelector);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "800px",
        bgcolor: 'white',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const getCpdateRange = (selectedFixtures: FixtureModel[]) => {
        let sortedFixtures = _.sortBy(selectedFixtures, (fixture) => {
            return (new Date(fixture.cpDate)).getTime();
        });

        return <>From <b>{Utility.DateFormat.formatDateString(sortedFixtures[0].cpDate)}</b> To <b>{Utility.DateFormat.formatDateString(sortedFixtures[sortedFixtures.length - 1].cpDate)}</b></>
    }

    const getCommEstd = (selectedFixtures: FixtureModel[]) => {
        let commEstd = 0;
        _.each(selectedFixtures, (fixture) => {
            if (!isNaN(fixture.estdComm)) {
                commEstd += fixture.estdComm;
            }
        });
        return <>{commEstd}</>;
    }

    const getCommCalculated = (selectedFixtures: FixtureModel[]) => {
        let commCalculated = 0;
        _.each(selectedFixtures, (fixture) => {
            if (!isNaN(fixture.bankReceived) && !isNaN(fixture.privateCommSettled)) {
                commCalculated += (fixture.bankReceived - fixture.privateCommSettled);
            }
        });
        return <>{commCalculated}</>;
    }

    const getFixtureByStatus = (selectedFixtures: FixtureModel[], statuses: string[]) => {
        return _.filter(selectedFixtures, (fixture) => {
            return _.indexOf(statuses, fixture.status) > -1;
        }).length;
    }

    return (
        <>
            <Modal
                open={quickInputData.showQuickSummaryModal}
                onClose={() => {
                    dispatch(setShowQuickSummaryModal(false));
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    {
                        quickInputData.selectedFixtures && quickInputData.selectedFixtures.length > 0 &&
                        <>
                            <h2>Quick Summary</h2>
                            <hr />
                            <br />
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Fixture count: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {quickInputData.selectedFixtures.length}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>CP Date: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getCpdateRange(quickInputData.selectedFixtures)}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Comm estd: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getCommEstd(quickInputData.selectedFixtures)}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Comm calculated: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getCommCalculated(quickInputData.selectedFixtures)}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>OnGoing Fixture count: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getFixtureByStatus(quickInputData.selectedFixtures, [SupportSheetStatus.PreArrivalLoadPort, SupportSheetStatus.OnVoyage, SupportSheetStatus.PreDelivery, SupportSheetStatus.Delivered])}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Outstanding Fixture count: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getFixtureByStatus(quickInputData.selectedFixtures, [SupportSheetStatus.PendingCommission, SupportSheetStatus.PendingLayTimeLTC, SupportSheetStatus.PendingFhs])}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={3}>
                                    <b>Closed Fixture count: </b>
                                </Grid>
                                <Grid item xs={9}>
                                    {getFixtureByStatus(quickInputData.selectedFixtures, [SupportSheetStatus.CloseFile, SupportSheetStatus.PendingDisputes, SupportSheetStatus.Cancel])}
                                </Grid>
                            </Grid>
                        </>
                    }
                </Box>
            </Modal>
        </>
    )
};

export default FixtureQuickSummary;